import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	makeStyles,
	Tooltip,
} from "@material-ui/core";
import DuoIcon from "@material-ui/icons/Duo";
import EmailIcon from "@material-ui/icons/Email";
import TelegramIcon from "@material-ui/icons/Telegram";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	icon: {
		minWidth: 40,
	},
	item: {
		color: theme.palette.primary[500],
	},
}));

const ContactMenu = ({ sidebarIsOpen }) => {
	const classes = useStyles();
	const translate = useTranslate();

	return (
		<List
			component="nav"
			aria-labelledby="nested-list-subheader"
			subheader={
				sidebarIsOpen && (
					<ListSubheader
						component="div"
						id="nested-list-subheader"
						style={{ textTransform: "uppercase" }}
					>
						{translate("ra.contacts")}
					</ListSubheader>
				)
			}
		>
			<Tooltip title="Email">
				<ListItem
					button
					component="a"
					dense
					href="mailto:assistenza.betaffiliation@gmail.com"
					className={classes.item}
				>
					<ListItemIcon className={classes.icon}>
						<EmailIcon />
					</ListItemIcon>
					<ListItemText primary="assistenza.betaffiliation" />
				</ListItem>
			</Tooltip>
			<Tooltip title="Skype">
				<ListItem
					button
					component="a"
					dense
					href="live:.cid.6cbc264fc06c5efe"
					target="_blank"
					rel="noopener noreferrer"
					className={classes.item}
				>
					<ListItemIcon className={classes.icon}>
						<DuoIcon />
					</ListItemIcon>
					<ListItemText primary="live:.cid.6cbc264fc06c5efe" />
				</ListItem>
			</Tooltip>
			<Tooltip title="Telegram">
				<ListItem
					button
					component="a"
					dense
					href="https://t.me/betaffiliation"
					target="_blank"
					rel="noopener noreferrer"
					className={classes.item}
				>
					<ListItemIcon className={classes.icon}>
						<TelegramIcon />
					</ListItemIcon>
					<ListItemText primary="https://t.me/betaffiliation" />
				</ListItem>
			</Tooltip>
		</List>
	);
};
export default ContactMenu;
